import styled from "styled-components";
import HorizontalScroller from "../../../../Scroller/HorizontalScroller";

export const Scroller = styled(HorizontalScroller)`
  min-width: 100%;
  position: relative;
  margin-bottom: 36px;
`;